export const checkoutMoney = (money, info) => {
  let reg = /^\d+(\.\d+)?$/;
  let errorMoneyTip = '';
  if (!money) {
    errorMoneyTip = '提现数额不能为空';
  } else if (!reg.test(money)) {
    errorMoneyTip = '请输入正确的数额';
  } else if (money > info.num) {
    errorMoneyTip = '超过可提现金额';
  } else if (money < info.min) {
    errorMoneyTip = `不满最小提现数额(${info.min})`;
  } else {
    errorMoneyTip = '';
  }
  return errorMoneyTip;
};
export const checkoutPhone = phone => {
  // 手机号为后端返回的已加密格式，不需再正则验证
  let errorPhoneTip = '';
  if (!phone) {
    errorPhoneTip = '手机号不能为空';
  } else {
    errorPhoneTip = '';
  }
  return errorPhoneTip;
};
export const checkoutCode = code => {
  let errorCodeTip = '';
  if (!code) {
    errorCodeTip = '验证码不能为空';
  } else {
    errorCodeTip = '';
  }
  return errorCodeTip;
};
